import { alpha, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import Table, { Column, TableProps } from 'further-ui/components/Table';
import {
  CalendarDay,
  numberToCurrencyString,
  pluralize,
} from 'further-ui/utils';
import { Column as LayoutColumn } from 'further-ui/components/Layout';
import Alert from 'further-ui/components/Alert';
type Operation = {
  id: string;
  date: CalendarDay;
  counterparty: string;
  description: string;
  spent?: number;
  received?: number;
  currency: string;
  hasError: boolean;
};

const columns: Array<Column<Operation>> = [
  {
    key: 'date',
    label: 'Date',
    render: (row) => row.date.toReadable(),
  },
  {
    key: 'counterparty',
    label: 'Counterparty',
  },
  {
    key: 'description',
    label: 'Description',
  },
  {
    key: 'spent',
    label: 'Spent',
    render: (row) =>
      numberToCurrencyString(row.spent, {
        fallback: '-',
        currency: row.currency,
      }),
  },
  {
    key: 'received',
    label: 'Received',
    render: (row) =>
      numberToCurrencyString(row.received, {
        fallback: '-',
        currency: row.currency,
      }),
  },
];

type Props = {
  operations: Array<Operation>;
  totalCount: number;
  totalErrors: number;
  pagination: NonNullable<TableProps<Operation, string>['pagination']>;
};

const Review: React.FC<Props> = ({
  operations,
  totalCount,
  totalErrors,
  pagination,
}) => {
  const alertSeverity = totalErrors ? 'error' : 'success';
  const summaryText = totalErrors
    ? `${totalErrors} ${pluralize('error', totalErrors)} found`
    : `${totalCount} ${pluralize('transaction', totalCount)} ${
        totalCount === 1 ? 'is' : 'are'
      } ready to import`;

  return (
    <LayoutColumn spacing="lg">
      <LayoutColumn spacing="sm">
        <Typography variant="h6">Review and complete import</Typography>

        <Alert severity={alertSeverity} iconPosition="start">
          {summaryText}
        </Alert>
      </LayoutColumn>

      <LayoutColumn spacing="sm">
        <Typography variant="h6">Transaction preview</Typography>
        <Table
          disableSorting
          columns={columns}
          rows={operations}
          rowsTotalCount={totalCount}
          pagination={pagination}
          getRowBackgroundColor={(row) =>
            row.hasError ? alpha(red[500], 0.3) : undefined
          }
        />
      </LayoutColumn>
    </LayoutColumn>
  );
};

export default Review;
